<template>
    <div class="not-avaliable d-flex flex-column align-items-center justify-content-center mt-auto mb-auto">
        <div class="not-avaliable__image-wrapper mb-6 mb-sm-5">
            <img
                src="../../assets/svg/not-avaliable-image.svg"
                alt="not avaliable"
                class="not-avaliable__image">
        </div>
        <h2 class="not-avaliable__title typo-h2-bold mb-1">
            К сожалению, эта страница недоступна
        </h2>
        <p class="not-avaliable__text typo-secondary-book">
            Вернитесь в каталог и зайдите на страницу повторно
        </p>
    </div>
</template>

<script>
export default {
    name: 'NotAvailableStub',
};
</script>

<style lang="scss">
.not-avaliable__image-wrapper {
    max-width: 572px;

    @include respond-max($desktop) {
        max-width: 565px;
    }

    @include respond-max($tablet) {
        max-width: 335px;
    }
}

.not-avaliable__image {
    display: block;
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
}
</style>
